import * as React from 'react'
import GameModel from '../models/Game'
import GameBoard from './GameBoard'

interface IGameProps {
  model: GameModel
}

export default class Game extends React.Component<IGameProps> {
  static instance: Game

  constructor(props: IGameProps) {
    super(props)

    Game.instance = this
  }

  static refresh() {
    Game.instance.forceUpdate()
  }

  render() {
    return <GameBoard model={this.props.model.currentBoard} key={this.props.model.currentBoardIndex}></GameBoard>
  }
}
